module.exports = __webpack_public_path__ + "01_short_black.c3ce87cb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_short_black.png
// module id = EKwk
// module chunks = 0